export default __webpack_public_path__ + "fonts/calendar-icon.svg";